<div class="header_search">
  <div class="title-page">
    <h3>Análise</h3>
  </div>
  <div class="content_search">
    <div class="new-demand" *ngIf="analiseList?.length">
      <button class="btn-back" type="btn" (click)="viewLast()">{{viewLastAnalises ? 'Ocultar' : 'Mostrar'}} Anteriores</button>
    </div>
    <div class="new-demand" *ngIf="getAnalise?.canCreateAnalysis">
      <a class="btn btn-primary" type="btn" [routerLink]="['/projetos', 'projeto', idProjeto, 'entregas', 'analise', 'adicionar']" [queryParams]="{ prt_issue_id: idEntrega }">Nova Análise</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th colspan="3">Situação</th>
          <th class="text-center">Atualização</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let analise of analiseList; let i = index">
          <tr *ngIf="analise?.last_one || viewLastAnalises">
            <td colspan="3">{{ analise?.description }}</td>
            <td>
              <div class="text-center">{{ analise?.ctr_usu_atu_name }}</div>
              <div class="text-center">{{ analise?.ctr_dth_atu }}</div>
            </td>
            <td class="btn-icon-td">
              <div class="btn-icon btn-icon-text">
                <a class="icon-table m-b-sm" [routerLink]="['/projetos', 'projeto', idProjeto, 'entregas', 'analise', analise?.id, 'editar']" *ngIf="analise?.last_one && getAnalise?.canCreateAnalysis && getAnalise?.isFullBlocked">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
                <span class="icon-table icon-red m-b-sm" (click)="confirmExcluir(analise?.id)" *ngIf="analise?.last_one && getAnalise?.isFullBlocked && getAnalise?.canCreateAnalysis">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                </span>
                <a class="icon-table icon-table-text" [routerLink]="['/projetos', 'projeto', idProjeto, 'demandas', 'adicionar']" [queryParams]="{ pf_prt_analysis_id: analise?.id }" *ngIf="analise?.last_one && getAnalise?.canDemand">
                  Nova demanda
                </a>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="analise?.analysis?.length && (analise?.last_one || viewLastAnalises)">
            <tr class="tr-line">
              <th class="title text-center">Titulo</th>
              <th class="text-center">Unid. Med.</th>
              <th class="text-center">Meta</th>
              <th class="text-center">Realizado</th>
              <th class="text-center">% Real</th>
            </tr>

            <tr *ngFor="let extra of analise?.analysis">
              <td class="title text-center">{{extra?.title}}</td>
              <td class="text-center">{{extra?.unit_id}}</td>
              <td class="text-center">{{extra?.goal}}</td>
              <td class="text-center">{{extra?.value_done}}</td>
              <td class="text-center">{{extra?.value_real}}</td>
            </tr>
          </ng-container>
        </ng-container>
        <tr *ngIf="!analiseList?.length" class="border-b-radius">
          <td colspan="5" class="text-center">Nenhuma Análise Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
